export default __webpack_public_path__ + "static/media/team-4.85c82b6e.jpg";